import { AfterViewInit, Component, inject } from '@angular/core';
import { TRANSLATIONS_IMPORTS } from '../../../shared/shared-exports/translation.exports';
import { AnimationService } from '../../../services/animation.service';
import { MATERIAL_IMPORTS } from '../../../shared/shared-exports/material.exports';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer-component',
  imports: [...TRANSLATIONS_IMPORTS, RouterLink, ...MATERIAL_IMPORTS],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer implements AfterViewInit {
  private animation = inject(AnimationService);
  currentYear = new Date().getFullYear();

  readonly socials = ['X', 'in', 'YT', 'FB'];

  readonly linkColumns = [
    {
      title: 'Platform',
      links: [
        { label: 'Dashboard', route: '/modules' },
        { label: 'Projects', route: '/projects' },
        { label: 'Analytics', route: '/mne/mne-sector' },
        { label: 'Data Collection', route: '/mne/projects-mel' },
        { label: 'Reports', route: '/documents' },
        { label: 'Indicators', route: '/mne/strategic-plans' },
      ],
    },
    {
      title: 'Resources',
      links: [
        { label: 'MEL Framework', route: '/frameworks' },
        { label: 'Documents & Articles', route: '/documents' },
        { label: 'Training Materials', route: '/documents' },
        { label: 'Policy Guides', route: '/documents' },
        { label: 'Vision 2050', route: '/home' },
      ],
    },
    {
      title: 'Institution',
      links: [
        { label: 'About the System', route: '/home' },
        { label: 'Enrolled Ministries', route: '/home' },
        { label: 'MEL Secretariat', route: '/home' },
        { label: 'Governance', route: '/home' },
        { label: 'FAQs', route: '/faqs' },
        { label: 'Contact Us', route: '/faqs' },
      ],
    },
  ];

  readonly legalLinks = [
    { label: 'Privacy Policy', route: '/home' },
    { label: 'Terms of Use', route: '/home' },
    { label: 'Accessibility', route: '/home' },
    { label: 'Sitemap', route: '/home' },
  ];

  readonly contacts: { icon: string; label: string; value: string; href?: string }[] = [
    { icon: 'location_on', label: 'Office Location', value: 'Mtumba Complex, Dodoma, Tanzania' },
    { icon: 'call', label: 'Helpdesk', value: '+255 (0) 26 232 1800 · Weekdays 08:00–17:00', href: 'tel:+255262321800' },
    { icon: 'mail', label: 'Email Support', value: 'mel.support@planning.go.tz', href: 'mailto:mel.support@planning.go.tz' },
    { icon: 'public', label: 'Portal', value: 'mel.planning.go.tz', href: 'https://mel.planning.go.tz' },
  ];

  ngAfterViewInit() {
    this.animation.scrollAnimate('.footer-content', {
      duration: 0.8,
      y: 40,
      stagger: 0.15,
    });
  }
}
